import _                                 from 'underscore';
import React, { FC }                     from 'react';
import { Checkbox, CheckboxProps, Form } from 'semantic-ui-react';
import { Cell, Grid }                    from "styled-css-grid";

import { SystemEvent }  from '../../../../../../types';
import { FieldWrapper } from '../../../../../components/forms/formik';

interface Props extends Pick<CheckboxProps, 'toggle' | 'slider'> {
	onChange?: CheckboxProps['onChange'],
	
	defaultChecked: boolean,
	label?: string,
	disabled?: boolean,
}

const defaultProps: Props = {
	onChange:       null,
	defaultChecked: null,
	label:          null,
	disabled:       false,
	toggle:         false,
	slider:         false,
}

const ToggleViewControl: FC<Props> = ( props ) => {
	
	return (
		
		<Form as={ 'div' }>
			
			<FieldWrapper>
				
				<Checkbox label={ props.label }
				          fitted={ !props.label }
				          defaultChecked={ props.defaultChecked }
				          onChange={ props.onChange }
				          disabled={ props.disabled }
				          toggle={ props.toggle }
				          slider={ props.slider }
				/>
			
			</FieldWrapper>
		
		</Form>
	)
};

/* ---------------- */

interface LabeledToggleSwitchViewControlProps extends Props {
	onLabelClick?( e: SystemEvent ): void,
	
	scaled?: boolean,
	scale?: number,
}

const labeledToggleSwitchDefaultProps: LabeledToggleSwitchViewControlProps = {
	...defaultProps,
	onLabelClick: ( e: SystemEvent ) => {},
	scaled:       false,
	scale:        0.8,
}

const LabeledToggleSwitch: FC<LabeledToggleSwitchViewControlProps> = ( props ) => {
	
	return (
		
		<Grid columns={ `auto 1fr` }
		      style={ {
			      transform:       props.scaled ? `scale(${ props.scale })` : null,
			      transformOrigin: props.scaled ? 'top center' : null,
		      } }>
			
			<Cell middle>
				
				<ToggleViewControl
					{ ..._.omit( props, 'label' ) }
					toggle={ true }
				/>
			
			</Cell>
			<Cell middle onClick={ props.disabled ? null : props.onLabelClick } className={ 'cursor--pointer' }>
				
				<span>{ props.label }</span>
			
			</Cell>
		</Grid>
	);
};

ToggleViewControl.defaultProps   = defaultProps;
LabeledToggleSwitch.defaultProps = labeledToggleSwitchDefaultProps;

export {
	ToggleViewControl,
	LabeledToggleSwitch
}
